import $ from "jquery";
import I18n from 'i18n.js.erb'
import { registerLocale, setDefaultLocale } from "react-datepicker";
import en from 'date-fns/locale/en-US';
import it from 'date-fns/locale/it';
import DOMPurify from 'dompurify';


/* QUESTO FILE CONTIENE UNA SERIE DI COSTANTI E FUNZIONI DI UTILITA'
   USATI LATO-CLIENT IN MOLTI PUNTI DIVERSI DEL PROGETTO */



/* ******************************* COSTANTI ******************************* */

// Tempo di debounce molto alto, da utilizzare soprattutto nei casi in cui devono mostrare sull'interfaccia grafica
// dei flash message
export const VERY_HIGH_DEBOUNCE_TIME = 2000;
export const VERY_VERY_HIGH_DEBOUNCE_TIME = 4000;

// Tempo di debounce alto, da utilizzare soprattutto nei casi in cui devono comparire
// popup di conferma a video
export const HIGH_DEBOUNCE_TIME = 1000;

// Tempo di debounce medio
export const MEDIUM_DEBOUNCE_TIME = 500;

// Tempo di debounce basso, da utilizzare nei casi in cui un utente potrebbe effettuare più modifiche
// velocemente, annullando i debounce precedenti
export const LOW_DEBOUNCE_TIME = 300;


// Tempo di transizione (espresso in millisecondi) delle animazioni di ease-in sull'interfaccia grafica
export const EASE_IN_TRANSITION_TIME = 800;


// Parametri di paginazione dei dati ritornati dal server
export const DEFAULT_PER_PAGE_PARAM = 50;
export const MEDIUM_PER_PAGE_PARAM = 35;
export const SMALL_PER_PAGE_PARAM = 25;


// Costanti che contengono i nomi di alcune chaivi usate per salvare dati localmente sul client
// (in particolare nel sessionStorage del browser)
export const EXPANSIONS_KEY_FOR_SESSION_STORAGE = 'expansionsPrevData'
export const SEALED_PRODUCTS_KEY_FOR_SESSION_STORAGE = 'sealedProductsPrevData'
export const BLUEPRINT_IMAGES_KEY_FOR_SESSION_STORAGE = 'blueprintImagesPrevData'
export const SHOP_KEY_FOR_SESSION_STORAGE = 'shopPrevData'
export const SHOP_SPECIFIC_OFFER_KEY_FOR_SESSION_STORAGE = 'ShopSpecifcOfferPrevData'
export const SUBMISSION_LIST_KEY_FOR_SESSION_STORAGE = 'submissionListPrevData_'
export const ITEM_TO_ADD_ON_SUBMISSION_LIST_KEY_FOR_SESSION_STORAGE = 'itemToAdd'
export const INSURANCE_TOU_ACCEPTED_KEY_FOR_SESSION_STORAGE = 'insuranceTouAccepted_'
export const INSURANCE_GUIDELINES_ACCEPTED_KEY_FOR_SESSION_STORAGE = 'insuranceGuidelinesAccepted_'
export const ITEM_TO_GRADE_KEY_FOR_SESSION_STORAGE = 'itemToGrade'
export const AUTOSAVING_ACCEPTED_KEY_FOR_LOCAL_STORAGE = 'autosavingAccepted'


// Costanti che contengono le dimensioni usate come riferimento in tutto il sito per discriminare gli ambienti
// smarthpone, tablet e desktop
export const IPAD_WIDTH = 768
export const DESKTOP_WIDTH = 991


// Costanti per l'identificazione delle varie monete
export const CURRENCY_EURO = '€'
export const CURRENCY_USDOLLAR = '$'
export const CURRENCY_POUND = '£'


// Costanti per le fasce di prezzo degli aggregatori
export const PRICE_RANGE_MAX_THRESHOLD = 9999999
export const DEFAULT_PRICE_RANGES = [
  { threshold: 300, discount: 20.0 },
  { threshold: 1000, discount: 25.0 },
  { threshold: 3000, discount: 28.0 },
  { threshold: 5000, discount: 31.0 },
  { threshold: 9999999, discount: 33.0 }
]


// Formatter per le date
export const IT_DATE_FORMATTER = new Intl.DateTimeFormat('it');


// Valutazioni delle submission lists (da 1 a 5 stelle)
export const SUBMISSION_LISTS_EVALUATIONS = [1, 2, 3, 4, 5]


// Stati inziali di una submission list
export const SUBMISSION_LIST_PRIOR_TO_RECEIPT_STATES = ['draft', 'pending_payment', 'payment_alert', 'confirmed', 'pick_up_requested', 'sent'];


// Stati finali di una submission list
export const SUBMISSION_LIST_POSTERIOR_UPON_RECEIPT_STATES = ['received', 'in_progress', 'completed', 'rejected', 'closed'];


// Stati terminali di una submission list
export const SUBMISSION_LIST_CLOSING_STATES = ['closed', 'rejected'];


// Parametro di paginazione di default dei record renderizzati nelle varie viste
export const PER_PAGE_OPTIONS = [25, 30, 40, 50]


// Lingue asiatiche
export const ASIATIC_LANGUAGES = [
  'jp', 'ko', 'th', 'zh', 'zht', 'zhs', 'id',
  'j', 'k', 't', 'z', 'zt', 'zs', 'i',
  'jap', 'kor', 'tha', 'czh', 'czht', 'czhs', 'ind',
  'JP', 'KO', 'TH', 'ZH', 'ZHT', 'ZHS', 'ID',
  'J', 'K', 'T', 'Z', 'ZT', 'ZS', 'I',
  'JAP', 'KOR', 'THA', 'CZH', 'CZHT', 'CZHS', 'IND'
]

// Lingue asiatiche con ideogrammi
export const IDEOGRAMS_LANGUAGES = [
  'jp', 'ko', 'th', 'zh', 'zht', 'zhs',
  'j', 'k', 't', 'z', 'zt', 'zs',
  'jap', 'kor', 'tha', 'czh', 'czht', 'czhs',
  'JP', 'KO', 'TH', 'ZH', 'ZHT', 'ZHS',
  'J', 'K', 'T', 'Z', 'ZT', 'ZS',
  'JAP', 'KOR', 'THA', 'CZH', 'CZHT', 'CZHS',
]

// Lingue inglesi
export const ENGLISH_LANGUAGES = [
  'en', 'us', 'as', 'eu',
  'e', 'u', 'a',
  'eng', 'usa', 'aus', 'eur',
  'EN', 'US', 'AS', 'EU',
  'E', 'U', 'A',
  'ENG', 'USA', 'AUS', 'EUR'
]

// Lingue europee
export const EUROPEAN_LANGUAGES = [
  'de', 'en', 'es', 'fr', 'it', 'nl', 'pl', 'pt',
  'd', 'e', 'f', 'i', 'n', 'l', 'p',
  'deu', 'eng', 'esp', 'fra', 'ita', 'ned', 'pol', 'pot',
  'DE', 'EN', 'ES', 'FR', 'IT', 'NL', 'PL', 'PT',
  'D', 'E', 'F', 'I', 'N', 'L', 'P',
  'DEU', 'ENG', 'ESP', 'FRA', 'ITA', 'NED', 'POL', 'POT'
]


// Costanti per Defectology
export const IMAGE_WIDTH = 468;
export const IMAGE_HEIGHT = 651;
export const IMAGE_AREA = IMAGE_WIDTH * IMAGE_HEIGHT;
export const ZOOM_FACTOR = 2;
export const LENS_RADIUS = 100;


// Funzione che ritorna i colori da usare per evidenziare il rettangolo di un difetto sull'interfaccia grafica
export const rectColors = (rect) => {
  let colors = { color: 'rgb(0, 128, 0)', bg: 'rgba(0, 128, 0, 0.2)', border: '2px solid rgb(73, 242, 14)', borderColor: 'rgb(73, 242, 14)' }
  if (rect.severity === 'medium')
    colors = { color: 'rgb(255, 140, 0)', bg: 'rgba(255, 140, 0, 0.2)', border: '2px solid rgb(255, 140, 0)', borderColor: 'rgb(255, 140, 0)' }
  else if (rect.severity === 'high')
    colors = { color: 'rgb(255, 24, 16)', bg: 'rgba(255, 24, 16, 0.2)', border: '2px solid rgb(255, 24, 16)', borderColor: 'rgb(255, 24, 16)' }
  return colors;
}


// Brand Pokemon
export const POKEMON_BRAND_NAMES = [
  'Pokemon', 'Pokémon', 'Pokèmon', 'ポケモンカードゲーム', '포켓몬 카드 게임', 'Pokémon Game Kartu Koleksi', 'โปเกมอน'
]


// Fasce orarie disponibili per il ritiro a domicilio delle submission lists
export const SUBMISSION_LISTS_HOME_PICK_UP_TIME_RANGES = [
  '8_12', '12_16', '15_19', 'all_day'
]



/* ************************** FUNZIONI DI UTLITA' ************************** */

// Funzione che ritorna, sulla base del numero di item da renderizzare su una certa pagina web, 4 opzioni ragionevoli
// di paginazione degli stessi sulla vista
export const calculatePerPageOptions = (itemsNumber) => {
  let perPageOptions = [];
  if (itemsNumber > PER_PAGE_OPTIONS[0]) {
    for (const option of [...PER_PAGE_OPTIONS, ...range(75, 50000, 25)]) {
      if (option > itemsNumber)
        break;
      if ((itemsNumber / option) <= 8)
        perPageOptions.push(option)
      if (perPageOptions.length === PER_PAGE_OPTIONS.length)
        break;
    }
  }
  if (perPageOptions.length === 0)
    perPageOptions = [...PER_PAGE_OPTIONS]
  return perPageOptions;
}

// Funzione che esegue un toString() customizzato
export const customToString = (value) => {
  if (!isDefined(value))
    return '';
  else
    return value.toString().trim();
}

// Funzione che esegue un confronto safe tra due stringe ricevute in input
export const compareStrings = (string1, string2) => {
  return string1 && string2 && string1.toString().trim().toLowerCase() === string2.toString().trim().toLowerCase();
}

// Funzione che estrae da una stringa la sottostringa che contiene tutti i numeri in essa eventualmente contenuti
export const extractSubstringBetweenNumbers = (inputString) => {
  let substringBetweenNumbers = '';
  const numbers = inputString.match(/\d+/g);
  if (numbers && numbers.length >= 1) {
    const firstNumberIndex = inputString.indexOf(numbers[0]);
    const lastNumberIndex = inputString.lastIndexOf(numbers[numbers.length - 1]);
    substringBetweenNumbers = inputString.substring(firstNumberIndex, lastNumberIndex + numbers[numbers.length - 1].length);
  }

  return substringBetweenNumbers;
}

// Funzione che costruisce un range, cioè un array di numeri compresi tra due estremi
export const range = (start, stop, step) => {
  return Array.from(
    { length: (stop - start) / step + 1 },
    (value, index) => start + index * step
  );
}


// Funzione che restituisce le traduzioni da renderizzare a video per una certa blueprint_image / espansione / era
export const displayTranslations = (en_name, meta_name, language) => {
  if (![...ENGLISH_LANGUAGES, ...EUROPEAN_LANGUAGES].includes(language)) {
    if (meta_name && en_name && en_name !== meta_name)
      return [en_name, meta_name]
    else
      return [meta_name ? meta_name : (en_name ? en_name : '')]
  } else {
    // if (meta_name && en_name && en_name !== meta_name)
    //   return [meta_name, en_name]
    // else
    return [meta_name ? meta_name : (en_name ? en_name : '')]
  }
}


// Funzione ch restituisce il nome completo (comprensivo del nome originale e del nome tradotto in inglese,
// se diverso dal primo) di una certa entità
export const fullName = (en_name, meta_name, language) => {
  const translations = displayTranslations(en_name, meta_name, language);
  if (translations.length === 1)
    return translations[0];
  else if (translations.length === 2)
    return translations[0] + ' (' + translations[1] + ')';
  else
    return '';
}


// Funzione che esegue il parsing del numero di carte gradate da renderizzare sull'interfaccia grafica
export const parseBigInteger = (cardNumber) => {
  switch (true) {
    case cardNumber > 99999 && cardNumber < 999999:
      return Math.round(((cardNumber / 1000) + Number.EPSILON) * 100) / 100 + ' K';
    case cardNumber > 999999:
      return Math.round(((cardNumber / 1000000) + Number.EPSILON) * 100) / 100 + ' MIL';
    default:
      return cardNumber;
  }
}


// Funzione che verifica se una submission list si trovi attualmente in uno stato precedente alla ricezione
export const isInAStatePriorToReceipt = (submissionList) => {
  return SUBMISSION_LIST_PRIOR_TO_RECEIPT_STATES.includes(submissionList?.state);
}


// Funzione che verifica se una submission list si trovi attualmente in uno stato posteriore alla ricezione
export const isInAStatePosteriorUponReceipt = (submissionList) => {
  return SUBMISSION_LIST_POSTERIOR_UPON_RECEIPT_STATES.includes(submissionList?.state);
}


// Funzione che verifica se una submission list si trovi attualmente in uno stato terminale
export const isInAClosingState = (submissionList) => {
  return SUBMISSION_LIST_CLOSING_STATES.includes(submissionList?.state);
}


// Funzione che esegue il parsing di uno slot orario
export const parseTimeRange = (timeRange) => {
  if (isDefined(timeRange)) {
    if (timeRange !== 'all_day') {
      const hours = timeRange.split("_");
      return `${hours[0]}:00 - ${hours[1]}:00`;
    } else
      return I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpAnyHour')
  } else
    return '';
}


// Funzione che esegue il parsing di un giorno e uno slot orario
export const parseDayAndTimeRange = (day, timeRange) => {
  if (isDefined(day) || isDefined(timeRange))
    return `${day} ${parseTimeRange(timeRange)}`;
  else
    return '';
}


// Funzione che esegue il parsing di un metodo di pagamento
export const parsePaymentMethod = (paymentMethod) => {
  return titleize(searchTranslation('js.editSubmissionListPage.webComponent.payment_methods', paymentMethod)).replaceAll('_', ' ');
}

export const selectNameByLanguage = (language, meta_name, en_name) => {
  return language.toLowerCase() === 'en' && en_name ? en_name : meta_name ? meta_name : (en_name || '-')
}

// Funzione che converte un numero intero in una data
export const parseDate = (dateIntValue) => {
  const dateStringValue = dateIntValue.toString()
  const year = dateStringValue.substring(0, 4)
  let month = dateStringValue.substring(4, 6)
  const day = dateStringValue.substring(6, 8)

  switch (month) {
    case '01':
      month = 'January'
      break;
    case '02':
      month = 'February'
      break;
    case '03':
      month = 'March'
      break;
    case '04':
      month = 'April'
      break;
    case '05':
      month = 'May'
      break;
    case '06':
      month = 'June'
      break;
    case '07':
      month = 'July'
      break;
    case '08':
      month = 'August'
      break;
    case '09':
      month = 'September'
      break;
    case '10':
      month = 'October'
      break;
    case '11':
      month = 'November'
      break;
    case '12':
      month = 'December'
      break;
    default:
      month = ''
      break
  }

  return year + ' ' + month + ' ' + day
}

// Funzione che effettua il parsing di una data in formato ISO
export const parseDateIsoFormat = (date, format) => {
  if (date) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    switch (format) {
      case '%Y-%m-%d':
        return `${year}-${month}-${day}`;
      case '%Y/%m/%d':
        return `${year}/${month}/${day}`;
      case '%d-%m-%Y':
        return `${day}-${month}-${year}`;
      case '%d/%m/%Y':
        return `${day}/${month}/${year}`;
      case '%Y-%m-%d, %H:%M':
        return `${year}-${month}-${day}T${hours}:${minutes}`;
      case '%d-%m-%Y, %H:%M':
        return `${day}-${month}-${year}, ${hours}:${minutes}`;
      case '%m-%d-%Y, %H:%M':
        return `${month}-${day}-${year}, ${hours}:${minutes}`;
      case '%m-%d-%Y, %H:%M':
        return `${month}-${day}-${year}, ${hours}:${minutes}`;
      case '%Y-%m-%d, %H:%M:00.000Z':
        return `${year}-${month}-${day}T${hours}:${minutes}:00.000Z`;
      default:
        return `${hours}:${minutes}:${seconds} - ${day}/${month}/${year}`;
    }
  } else
    return '';
}

// Funzione che converte una data in utc
export const convertToUTC = (localDateString) => {
  if (localDateString) {
    const localDate = new Date(localDateString);
    const utcTimestamp = localDate.getTime() + (localDate.getTimezoneOffset() * 60000);
    const utcDate = new Date(utcTimestamp);

    return utcDate;
  } else
    return null;
}

// Funzione che converte una data da utc a local
export const convertToLocal = (utcDateString = null) => {
  // Crea un oggetto Date UTC dalla stringa UTC
  const utcDate = utcDateString ? new Date(utcDateString) : new Date();

  // Ottieni il timestamp UTC della data
  const utcTimestamp = utcDate.getTime();

  // Ottieni l'offset del fuso orario locale in millisecondi
  const localOffset = new Date().getTimezoneOffset() * 60000;

  // Crea un oggetto Date locale aggiungendo l'offset
  const localTimestamp = utcTimestamp - localOffset;

  // Crea un oggetto Date locale
  const localDate = new Date(localTimestamp);

  return localDate;
}

// Funzione che converte una data da utc
export const convertToDate = (utcDateString = null) => {
  // Crea un oggetto Date UTC dalla stringa UTC
  const utcDate = utcDateString ? new Date(utcDateString) : new Date();

  // Ottieni il timestamp UTC della data
  const utcTimestamp = utcDate.getTime();

  // Crea un oggetto Date locale
  const date = new Date(utcTimestamp);

  return date;
}


// Funzione che converte una stringa in una static_string intesa come da model di database,
// cioè in un oggetto che contiene il nome completo e il nome abbreviato della stringa stessa
export const parseStaticString2Object = (static_string, short_name_1) => {
  return {
    meta_name: static_string,
    short_name_1: isPresent(short_name_1) ? short_name_1 : static_string
  }
}


// Funzione che esegue il parsing di un certo ammontare monetario
export const parseAmount = (value, toFixed, convertNullValueToZero) => {
  if (isPresent(value)) {
    var amount = parseFloat(value).toFixed(isDefined(toFixed) && toFixed >= 0 ? toFixed : 2).toString().replace('.', ',');

    if (value >= 1000.0) {
      amount = amount.split('', amount.length).reverse().join('').replace(/([0-9]{3})/g, '$1.');
      amount = amount.split('', amount.length).reverse().join('');
    }
    if (amount[0] === '.')
      amount = amount.substring(1)

    return amount;
  } else if (convertNullValueToZero) {
    return toFixed === 0 ? '0' : '0,00';
  }
}


// Funzione che esegue il parsing di una fascia di prezzi
export const pricesRange = (values, toFixed, convertNullValueToZero) => {
  return values.map((value, index) => index == 0 && values.length > 1 ? parseAmount(value, toFixed, convertNullValueToZero).replaceAll(',00', '') : parseAmount(value, toFixed, convertNullValueToZero));
}


// Funzione che collassa una fascia di prezzi in una stringa vuota
// se i valori da renderizzare sono più di uno e se l'ammontare finale non è gratuito
export const pricesRangeCollapse = (values, toFixed, convertNullValueToZero, free) => {
  if (free)
    return ` +0,00${CURRENCY_EURO}`
  else if (values?.length === 1)
    return ` +${pricesRange(values, toFixed, convertNullValueToZero).join('-')}${CURRENCY_EURO}`;
  else return "";
}


// Funzione che scorpora l'iva da un certo importo
export const extractVat = (amount, vatRate) => {
  if (isDefined(amount) && isDefined(vatRate))
    return (100.0 * parseFloat(amount)) / (100.0 + (parseFloat(vatRate)));
  else
    return null;
}


// Funzione che esegue il parsing di un certo ammontare monetario e, qualora fosse pari a zero,
// esplicita il fatto che sia gratuito
export const parsePotentiallyFreeAmount = (value, toFixed, convertNullValueToZero, condition, includePlusSymbol) => {
  if (condition)
    return I18n.t('js.editSubmissionListPage.webComponent.draft.freeShipping.gratis');
  const parsedAmount = parseAmount(value, toFixed, convertNullValueToZero);
  if (parsedAmount)
    return `${includePlusSymbol ? '+' : ''}${parsedAmount}${CURRENCY_EURO}`
  else
    return '';
}


// Funzione che esegue un parsing customizzato di una stringa o di un numero intero a un float con un certo numero di
// decimali dopo la virgola
export const customParseFloat = (value, toFixed, convertNullValueToZero) => {
  if (isPresent(value)) {
    const floatValue = parseFloat(value);
    if (!isNaN(floatValue))
      return floatValue.toFixed(isDefined(toFixed) && toFixed >= 0 ? toFixed : 2);
    else if (convertNullValueToZero)
      return toFixed === 0 ? 0 : 0.00;
    else
      return null;
  }
  else if (convertNullValueToZero)
    return toFixed === 0 ? 0 : 0.00;
  else
    return null;
}


// Funzione che parsa il grade overall di una carta o di un prodotto sigillato che va renderizzato a video
export const parseGradeOverall = (grading, compact) => {
  if (grading.is_authentic || grading.is_authentic_with_subgrades)
    return compact ? 'A' : 'AUTHENTIC';
  else if (grading.is_case_fresh)
    return compact ? 'CF' : 'CASE FRESH';
  else if (grading.grade_overall)
    return stringifyGrading(grading.grade_overall);
  else
    return null;
}


// Funzione che verifica se una certa gradazione sia un 10 Pristine oppure no
export const is10Perfect = (grading) => {
  return isDefined(grading) &&
    grading.is_10_perfect &&
    !grading.is_authentic &&
    !grading.is_authentic_with_subgrades &&
    !grading.is_case_fresh;
}



// Funzione che parsa un grade centering di una carta o di un prodotto sigillato che va renderizzato a video
export const parseGradeCentering = (gradeCentering) => {
  if (gradeCentering.toLowerCase().trim() === 'na')
    return I18n.t('js.productInfoPage.notAvailableGrading')
  else
    return gradeCentering.replaceAll('_', '-')
}


// Funzione che converte un voto in una stringa
export const stringifyGrading = (grade) => {
  if (isDefined(grade))
    return grade.toString().replaceAll(',0', '').replaceAll('.0', '').replaceAll(',', '.');
  else
    return '';
}


// Funzione che estrae la traduzione di una label nella lingua di navigazione dell'utente corrente sul sito web
const searchTranslation = (i18nPath, key, transformKey = true) => {
  const translatedName = I18n.t(`${i18nPath}${key ? '.' + (transformKey ? key.toLowerCase().replaceAll(' ', '_') : key) : ''}`)
  if (translatedName && translatedName.indexOf('missing') === -1)
    return translatedName
  else
    return key
}


// Funzione che restituisce il colore da associare allo stato corrente di una certa submission list
export const submissionListColorState = (state) => {
  return state === 'draft' ? 'gray' :
    state === "pending_payment" ? "#E6418B" :
      state === "sent" ? "#c892e0" :
        state === "pick_up_requested" ? "#B95417" :
          state === "received" ? "darkOrange" :
            state === "in_progress" ? "#007BFF" :
              ["rejected", "payment_alert"].includes(state) ? "red" :
                ["completed", "closed"].includes(state) ? "#4cae4c" :
                  "black";
}


// Funzione che restituisce il colore da associare allo stato corrente di una certa fattura
export const invoiceColorState = (state) => {
  return state === "unpaid" ? "darkOrange" :
    state === "paid" ? "#4cae4c" :
      "black";

}


// Funzione che restituisce il colore da associare allo stato corrente di un certo annuncio di vendita
export const saleItemColorState = (state) => {
  return state === 'draft' ? 'gray' :
    state === "scheduled" ? "darkOrange" :
      state === 'listing' ? "#008FDB" :
        state === "expired" ? "#c892e0" :
          state === "on_sale" ? "#4cae4c" :
            state === "sold" ? "#ffcf40" :
              "black";
}


// Funzione che restituisce la stringa corrispondente alla traduzione dello stato di una submission list
export const parseSubmissionListState = (state) => {
  return searchTranslation('js.common.submissionListState', state)
}


// Funzione che restituisce la stringa corrispondente alla traduzione del motivo di reject di un item presente
// all'interno di una submission list
export const parseSubmissionListItemRejectionReason = (rejectionReason) => {
  return searchTranslation('js.modalRejecting', `${toCamelCase(rejectionReason)}Singular`, false)
}


// Funzione che restituisce la stringa corrispondente alla traduzione dello stato della submission list
export const parseLanguageAcronim = (acronim) => {
  return searchTranslation('js.common.languageAcronyms', acronim)
}


// Funzione che verifica se sia stato richiesto la copertura assicurativa per una submission list durante le spedizioni
export const insuranceRequested = (submissionList) => {
  return isPresent(submissionList.insured_value) || submissionList.insurance_range_id || isPresent(submissionList.estimated_value) || isPresent(submissionList.insurance_range);
}


// Funzione che verifica se l'importo corrente di una submission list vada evidenziato in rosso sull'interfaccia grafica
export const warnSubmissionListAmount = (submissionList) => {
  return submissionList.check_amount || submissionList.state === 'payment_alert' ? ['red', true] : (submissionList.check_not_paid_amount ? ['darkOrange', true] : ['green', false])
}


// Funzione che renderizza un eventuale messaggio di warning sull'importo pagato dall'utente o dall'aggregatore
// per una certa submission list
export const warnSubmissionListAmountMessage = (submissionList, amountType) => {
  if (submissionList.check_not_paid_amount && isDefined(submissionList.user_debit))
    return `L'utente, per pagare questa submission list, ha utilizzato un credito eccessivo che non era disponibile sul suo wallet e al momento risulta essere in debito di ${parseAmount(submissionList.user_debit, 2)}${CURRENCY_EURO}`;
  else if (submissionList.check_amount)
    return `Check the ${amountType ? amountType : 'Amount'}!`;
  else return 'Not paid yet';
}


// Funzione che verifica se per una certa submission list sia stato richiesto il pagamento differito
export const checkDeferredPayment = (paymentTerms) => {
  return paymentTerms && paymentTerms.toLowerCase().indexOf('deferred') > -1
}


// Funzione che ritorna il massimo credito usabile dall'utente per pagare la sua submission list
export const submissionListMaxUsableCredit = (submissionList) => {
  if (!isPresent(submissionList?.user_wallet?.amount) || !isPresent(submissionList?.all_services_amount))
    return 0;
  else
    return Math.min(submissionList.user_wallet.amount, Math.floor(submissionList.all_services_amount))
}


// Funzione che stilizza il badge sulla navbar del sito che segnala all'utente la giacenza attuale sul suo wallet
export const handleRenderWalletBadge = (newWalletAmount) => {
  removeHtmlElementClass(document, 'wallet_amount_container', 'right--40perc-imp');
  removeHtmlElementClass(document, 'wallet_amount_container', 'right--55perc-imp');
  if (isDefined(newWalletAmount)) {
    if (parseInt(newWalletAmount) < 10)
      addHtmlElementClass(document, 'wallet_amount_container', 'right--40perc-imp');
    else if (parseInt(newWalletAmount) < 100)
      addHtmlElementClass(document, 'wallet_amount_container', 'right--55perc-imp');
  }
}


// Funzione che restituisce la traduzione del titolo di una my collection nella lingua corrente
export const parseMyCollectionTitle = (myCollection, locale) => {
  if (['it'].includes(locale))
    return searchTranslation('js.myCollectionEditPage.myCollectionTitle') + ' ' + parseGameName(myCollection.game);
  else
    return myCollection.title;
}


// Funzione che restituisce la stringa corrispondente alla traduzione della condizione di un articolo
export const parseItemCondition = (condition) => {
  return searchTranslation('js.myCollectionEditPage.condition', condition)
}


// Funzione che restituisce la stringa corrispondente alla traduzione del tipo di grading di un articolo
export const parseRequestedService = (service) => {
  return searchTranslation('js.myCollectionEditPage.requestedService', service)
}


// Funzione che restituisce la traduzione della lingua utilizzata
export const translateLanguage = (language) => {
  return `js.common.language${parseLocale(language).toUpperCase()}`
}


// Funzione che restituisce l'acronimo a 3 caratteri di una certa lingua
export const parseLocale = (language) => {
  switch (language) {
    case 'it':
      return 'ita'
    case 'en':
      return 'eng'
    case 'jp':
      return 'jap'
    case 'us':
      return 'usa'
    case 'as':
      return 'aus'
    case 'eu':
      return 'eur'
    case 'de':
      return 'deu'
    case 'fr':
      return 'fra'
    case 'es':
      return 'esp'
    case 'nl':
      return 'ned'
    case 'pt':
      return 'pot'
    case 'pl':
      return 'pol'
    case 'ru':
      return 'rus'
    case 'id':
      return 'ind'
    case 'th':
      return 'tha'
    case 'ko':
      return 'kor'
    case 'zh':
      return 'czh'
    case 'zht':
      return 'czht'
    case 'zhs':
      return 'czhs'
    case 'ph':
      return 'phi'
    case 'ev':
      return 'elv'
    case 'ag':
      return 'agl'
    case 'xx':
      return 'xxx'
    default:
      return language
  }
}


// Funzione che converte un acronimo di lingua a 2 caratteri nella corrispettiva lingua scritta per esteso
export const convertLocaleToLanguage = (locale) => {
  switch (locale.toLowerCase()) {
    case 'it':
      return 'Italian'
    case 'en':
      return 'English'
    case 'jp':
      return 'Japanese'
    case 'us':
      return 'English'
    case 'as':
      return 'English'
    case 'eu':
      return 'English'
    case 'de':
      return 'German'
    case 'fr':
      return 'French'
    case 'es':
      return 'Spanish'
    case 'nd':
      return 'Dutch'
    case 'pt':
      return 'Portuguese'
    case 'pl':
      return 'Polish'
    case 'ru':
      return 'Russian'
    case 'id':
      return 'Indonesian'
    case 'th':
      return 'Thai'
    case 'ko':
      return 'Korean'
    case 'zh':
      return 'Chinese'
    case 'zht':
      return 'Traditional Chinese'
    case 'zhs':
      return 'Simplified Chinese'
    case 'ph':
      return 'Phyrexian'
    case 'ev':
      return 'Elvish'
    case 'ag':
      return 'Astral Glyphs'
    case 'xx':
      return 'None'
    default:
      return locale
  }
}


// Funzione che restituisce la stringa corrispondente alla traduzione dello stato dell'ordine
export const parseOrderState = (state) => {
  return searchTranslation('js.common.ordersState', state)
}


// Funzione che, data una stringa, restituisce la stringa con l'iniziale maiuscola
export const titleize = (initialString) => {
  if (isDefined(initialString))
    return (initialString.charAt(0).toUpperCase() + initialString.slice(1)).replaceAll('_', ' ')
  else
    return ""
}


// Funzione che, data una stringa, restituisce la stringa con l'iniziale maiuscola
// in tutte le parole che contiene al suo interno
export const titleizeAll = (initialString) => {
  if (initialString)
    return initialString.replaceAll('_', ' ').replace(/\b\w/g, match => match.toUpperCase());
  else
    return ""
}


// Funzione che pluralizza una determinata stringa in base al numero di items ricevuti in input. In particolare,
// se il numero di items è pari a 1, allora restituisce la stringa al singolare, altrimenti restituisce la rispettiva
// stringa al plurale
export const pluralize = (itemsCount, key) => {
  if (key) {
    const pluralizedKey = itemsCount === 1 ? `${key}` : `${key}s`
    const translation = I18n.t(`js.${pluralizedKey}`)
    if (translation && translation.indexOf("missing") === -1)
      return translation
    else
      return pluralizedKey
  } else {
    return ''
  }
}


// Espressione regolare per la validazione delle email
export const emailRegExp = RegExp(
  "^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
);


// Funzione che si occupa di validare la correttezza sintattica di una email
export const isValidEmail = (email) => {
  return emailRegExp.test(email)
}

// Funzione che si occupa di validare la correttezza sintattica di un indirizzo di un utente
export const isValidFirstName = (address) => {
  return address.first_name !== null && address.first_name.trim().length >= 2
}
export const isValidLastName = (address) => {
  return address.last_name !== null && address.last_name.trim().length >= 2
}
export const isValidCountry = (address) => {
  return isPresent(address.country_id);
}
export const isValidCity = (address) => {
  return address.city !== null && address.city.trim().length >= 3
}
export const isValidProvince = (address) => {
  return address.province !== null && address.province.trim().length >= 2
}
export const isValidStreetSquare = (address) => {
  return address.street_square !== null && address.street_square.trim().length >= 3
}
export const isValidNumber = (address) => {
  return address.number !== null && address.number.trim().length >= 1
}
export const isValidCap = (address) => {
  return address.cap !== null && address.cap.trim().length >= 1
}
export const isValidPhoneNumber = (address) => {
  return address.phone_number !== null && address.phone_number.replaceAll(' ', '').length >= 9
}

export const isValidAddressEmail = (address) => {
  return address.email !== null && isValidEmail(address.email.trim());
}

export const isValidUserAddress = (address, deliveryMethod, ignorePhoneNumber, ignoreEmail) => {
  if (deliveryMethod?.meta_name?.toLowerCase()?.indexOf('by hand') > -1)
    return true
  else
    return (isValidFirstName(address) &&
      isValidLastName(address) &&
      isValidCountry(address) &&
      isValidCity(address) &&
      isValidProvince(address) &&
      isValidStreetSquare(address) &&
      isValidNumber(address) &&
      isValidCap(address) &&
      (isValidPhoneNumber(address) || ignorePhoneNumber) &&
      (isValidAddressEmail(address) || ignoreEmail)
    )
}


// Funzione che ritorna la lingua in cui visualizzare il calendario in base alla lingua
// in cui è impostata l'applicazione
export const setLocaleInDataPiker = () => {

  //Funzione del datapiker di react che mi permette di impostare alcune lingue in cui tradurre il calendario
  registerLocale('en', en)
  registerLocale('it', it)

  if (I18n.locale === 'it') {
    setDefaultLocale('it')
    return "it"
  } else {
    setDefaultLocale('en')
    return "en"
  }
}


//Funzione jquery che mi permette di gestire la variazione dello z-index
// dell'eleento con id "idElement" quando scrollo la pagina
export const scrollManagerInTabPages = (idElement) => {
  if ($(window).scrollTop() > 0) {
    $(idElement).css("z-index", "99");
  } else {
    $(idElement).css("z-index", "101");
  }
}


// Funzione che verifica se u n certo elemento si trovi all'interno della viewport oppure no
export const isInViewport = (element) => {
  if (element) {
    var bounding = element.getBoundingClientRect();
    return bounding.top >= 0 && bounding.left >= 0 &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
  } else {
    return false;
  }
}

// Funzione che setta l'altezza che deve essere associata a un tag html <img> in funzione della size che la relativa
// immagine deve avere al momento del rendering
export const setImgTagHeight = (size) => {
  switch (size) {
    case 'thumb':
      return '100'
    case 'shrinked_medium':
      return '150'
    case 'medium':
      return '240'
    case 'large':
      return '350'
    case 'x_large':
      return '651'
  }
}

// Funzione che setta l'altezza che deve essere associata a un tag html <img> in funzione della size che la relativa
// immagine deve avere al momento del rendering
export const setProductMenuTagHeight = (size) => {
  switch (size) {
    case 'thumb':
      return '410'
    case 'shrinked_medium':
      return '460'
    case 'medium':
      return '550'
    case 'large':
      return '660'
    case 'x_large':
      return '771'
  }
}

// Funzione che setta l'altezza che deve essere associata a un tag html <img> in funzione della size che la relativa
// immagine deve avere al momento del rendering
export const setProductMenuTagWidth = (size) => {
  switch (size) {
    case 'thumb':
      return '110'
    case 'shrinked_medium':
      return '160'
    case 'medium':
      return '250'
    case 'large':
      return '360'
    case 'x_large':
      return '671'
  }
}


// Funzione che setta la larghezza che deve essere associata a un tag html <img> in funzione della size che la relativa
// immagine deve avere al momento del rendering
export const setImgTagWidth = (size) => {
  switch (size) {
    case 'thumb':
      return '70'
    case 'shrinked_medium':
      return '108'
    case 'medium':
      return '173'
    case 'large':
      return '251'
    case 'x_large':
      return '468'
  }
}


// Funzione che si occupa di gestire la navigazione "all'indietro" fino alla pagina corrente: in questo caso tutti i
// dati necessari per gestire questa pagina vengono caricati dal sessionStorage del browser e non vengono fatte
// richieste al server per ricaricare i dati
export const handleBackPage = (sessionStorageKey, sessionStorageData, functions) => {
  let setLoadDataFromSessionStorage = functions['setLoadDataFromSessionStorage'];
  setLoadDataFromSessionStorage(true);

  for (let k in sessionStorageData) {
    if (k !== 'scrollY') {
      let currentFuncName = 'set' + titleize(k);
      let setFunction = functions[currentFuncName];
      if (setFunction) {
        setFunction(sessionStorageData[k]);
      }
    }
  }

  setLoadDataFromSessionStorage(false);
  /*
  hack per far funzionare il riposizionamento del cursore anche su safari
   */
  if (sessionStorageData.scrollY) {
    setTimeout(function () {
      window.scrollTo({ top: sessionStorageData.scrollY });
    }, 300);
  }

  sessionStorage.removeItem(sessionStorageKey);
}


// Funzione che costruisce una select editabile per le espansioni da usare nei vari filtri di ricerca
export function buildEditableSelect(handleChangeFilterValue, preventRemoveEventListener) {
  $(document).ready(function () {
    function formatState(state) {
      if (!state.id) {
        return state.text;
      }

      var $state = $(
        (state.element.label !== state.text ?
          '<span><img src="' + state.element.label + '" width="20" alt=""/> ' + state.text + '</span>'
          :
          '<span>' + state.text + '</span>'
        )
      );
      return $state;
    }

    if (handleChangeFilterValue) {
      let select2_custom = $(".select2-custom")
        .select2({
          templateResult: formatState,
          dropdownAutoWidth: true
        })
      if (!preventRemoveEventListener)
        select2_custom = select2_custom.off('change')
      select2_custom
        .on("change", handleChangeFilterValue);
    }
    else
      $('.select2-custom')
        .select2({
          templateResult: formatState,
          dropdownAutoWidth: true
        })
  });
}

// Funzione che converte una stringa di input nella corrispondente stringa in camelCase
export const toCamelCase = (str) => {
  return str
    .split('_') // Divido la stringa in un array usando l'underscore come delimitatore
    .map((word, index) => {
      if (index === 0) {
        return word.toLowerCase(); // Mantengo l'iniziale minuscola per la prima parola
      }
      // Capitalizzo la prima lettera delle parole successive
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(''); // Ricompongo l'array in una stringa
}


// Funzione che converte una stringa di input in un booleano
export const toBoolean = (str) => {
  return str?.toLowerCase() === 'true'
}

export const parseUserFullName = (firstName, lastName) => {
  return (customToString(firstName) + ' ' + customToString(lastName)).trim();
}

export const parseUserGeneralities = (username, fullName, email) => {
  let parsedString = customToString(username);

  if (isDefined(parsedString) && fullName && username !== fullName)
    parsedString = parsedString + ' - ' + customToString(fullName);
  else
    parsedString = customToString(fullName);

  if (isDefined(parsedString) && email && email !== username && email !== fullName)
    parsedString = parsedString + ' (' + customToString(email) + ')';
  else
    parsedString = customToString(email);

  return parsedString;
}


// Costante che contiene i parametri necessari per impostare un nuovo indirizzo
export const EMPTY_ADDRESS = {
  first_name: "",
  last_name: "",
  co: "",
  country_id: null,
  country: "",
  city: "",
  province: "",
  street_square: "",
  indoor: "",
  number: "",
  cap: "",
  phone_number: "",
  email: "",
  residence: false,
  deleted: false,
  is_default: false,
  can_be_updated: true
}


// Funzione che parsa un certo indirizzo da renderizzare a video
export const parseShipmentAddress = (address, locale = I18n.locale) => {
  if (address)
    return (
      parseUserFullName(address.first_name, address.last_name) +
      (address.co ? ' ' + I18n.t('js.newUserAddressForm.co', {locale: locale}) + ' ' + address.co : '') + ': ' +
      titleize(address.street_square) + ' ' + address.number +
      (address.indoor ? ', ' + I18n.t('js.newUserAddressForm.indoor', {locale: locale}) + ' ' + address.indoor : '') + ', ' +
      address.cap + ' ' +
      (address.city.toUpperCase() !== address.province.toUpperCase() ? ' ' + titleize(address.city) : '') +
      ' - ' + address.province.toUpperCase() +
      ' (' + address.country.toUpperCase() + ')' +
      (address.phone_number ? ' - ' + I18n.t('js.newUserAddressForm.tel', {locale: locale}) + ': ' + address.phone_number : '') +
      (address.email ? ' - ' + I18n.t('js.indexSubmissionListsPage.tableHeaderUserEmail', {locale: locale}) + ': ' + address.email : '')
    );
  else
    return '';
}


// Funzione che parsa il nome di un metodo di consegna da renderizzare a video
export const parseDeliveryMethod = (deliveryMethod) => {
  return deliveryMethod?.meta_name?.toLowerCase()?.indexOf('by hand') > -1 ? I18n.t('js.editSubmissionListPage.pickUpByHand') : deliveryMethod?.meta_name;
}

// Funzione che parsa il numero di giorni impiegati per processare una submission list
export const parseSubmissionListProcessingTime = (submissionList) => {
  if (isPresent(submissionList?.processing_time)) {
    if (submissionList.processing_time === 0)
      return '< 1 day'
    else
      return submissionList.processing_time + (submissionList.processing_time === 1 ? ' day' : ' days')
  } else
    return '';
}

// Funzione che parsa la stringa che indica il device da cui è stata creata una submission list
export const parseSubmissionListCreationDevice = (submissionList) => {
  let device = '';

  if (isDefined(submissionList.created_through) && !['other', 'third_party_api'].includes(submissionList.created_through))
    device = device + ' ' + titleize(submissionList.created_through).replaceAll('_', ' ')

  if (isDefined(submissionList.creation_device) && !['other'].includes(submissionList.creation_device))
    if (submissionList.creation_device === 'mobile' && submissionList.created_through === 'third_party_api')
      device = device + 'Mobile App'
    else
      device = device + ' on ' + titleize(submissionList.creation_device.replaceAll('_', ' '))

  if (isDefined(submissionList.creation_platform) && !['other'].includes(submissionList.creation_platform))
    device = device + ' - ' + titleize(submissionList.creation_platform).replaceAll('_', ' ')

  return device;
}

// Funzione che verifica se a una submission list sia associato un coupon di sconto
export const hasVoucher = (submissionList) => {
  return submissionList.voucher?.amount || submissionList.voucher?.percentage
}

// Funzione che verifica se a una submission list sia associato un coupon di sconto valido
export const hasValidVoucher = (submissionList) => {
  return hasVoucher(submissionList) && submissionList.voucher?.valid_voucher
}


// Funzione che verifica se per una certa submission list sia stato abilitato il servizio extra dell'assicurazione del 
// pacco durante le spedizioni
export const insuranceServiceEnabled = (submissionList) => {
  return (
    submissionList.grader_company?.has_insurance_options ||
    insuranceRequested(submissionList) ||
    isPresent(submissionList.insurance_cost)
  )
}


// Funzione che verifica se per una certa submission list sia stato abilitato il servizio extra 
// di ritiro a domicilio del pacco
export const homePickUpServiceEnabled = (submissionList) => {
  return (
    (isPresent(submissionList.grader_company?.home_pick_up_method) ||
      submissionList.home_pick_up_requested ||
      isPresent(submissionList.home_pick_up_cost))
  )
}


// Funzione che esegue il parsing del giorno richiesto per il ritiro a domicilio di una submission list
export const parseHomePickUpFavoriteDay = (homePickUpFavoriteDay) => {
  if (isDefined(homePickUpFavoriteDay) && homePickUpFavoriteDay.toLowerCase() !== 'all_day') {
    const date = homePickUpFavoriteDay.split('-');
    return `${date[2]}/${date[1]}/${date[0]}`
  } else
    return '';
}


// Funzione che esegue il parsing della fascia oraria richiesta per il ritiro a domicilio di una submission list
export const parseHomePickUpFavoriteHour = (homePickUpFavoriteHour) => {
  if (isDefined(homePickUpFavoriteHour)) {
    const timeRange = homePickUpFavoriteHour.split('_');
    return `${timeRange[0]}:00 - ${timeRange[1]}:00`
  } else
    return '';
}


// Funzione che verifica se per una certa submission list sia stato abilitato il servizio extra di consegna 
// di ritorno a domicilio del pacco
export const returnShipmentServiceEnabled = (submissionList) => {
  return (
    (isPresent(submissionList.grader_company?.return_delivery_method) ||
      submissionList.return_delivery_requested ||
      isPresent(submissionList.shipping_cost))
  )
}


export const renderHomePickuServiceDetails = (submissionList) => {
  return !submissionList.hide_shipment_and_invoicing_info_to_user &&
    homePickUpServiceEnabled(submissionList)
}

export const renderReturnShipmentServiceDetails = (submissionList) => {
  return !submissionList.hide_shipment_and_invoicing_info_to_user &&
    returnShipmentServiceEnabled(submissionList)
}

// Funzione che parsa il nome di una category da renderizzare a video
export const parseCategoryName = (categoryName) => {
  return searchTranslation('js.common.categories', categoryName)
}

// Funzione che parsa il nome di un feedback da renderizzare a video
export const parseFeedbackName = (feedbackName) => {
  return searchTranslation('js.feedbacks', feedbackName)
}


// Funzione che restituisce l'eventuale valutazione numerica dell'utente a un determinato parametro di valutazione
// impostato dalla casa di gradazione per la submission list
export const getEvaluationByFeedback = (feedback, evaluations) => {
  if (isDefined(evaluations) && isDefined(evaluations[feedback?.id]))
    return evaluations[feedback.id];
  else
    return 0;
}


// Funzione che parsa una lingua da renderizzare a video
export const parseLanguage = (languages) => {
  if (languages) {
    let translatedLanguages = "";
    const allLanguages = languages.replaceAll(' ', '').split(",");

    for (const language of allLanguages) {
      const translatedLanguage = I18n.t(`js.common.languageAllList.${language.toLowerCase().replaceAll(" ", "_")}`);
      if (translatedLanguage && translatedLanguage.indexOf("missing") === -1)
        translatedLanguages = translatedLanguages + translatedLanguage + ",";
      else
        translatedLanguages = translatedLanguages + language + ",";
    }

    if (translatedLanguages && translatedLanguages.length > 0 && translatedLanguages[translatedLanguages.length - 1] === ',')
      translatedLanguages = translatedLanguages.slice(0, -1)

    return translatedLanguages.replaceAll(',', ', ')
  } else {
    return ''
  }
}

// Funzione che parsa la lingua di stampa di etichetta da renderizzare a video
export const parseLabelLanguage = (labelLanguage) => {
  if (labelLanguage !== 'native')
    return titleize(labelLanguage);
  else
    return I18n.t('js.editSubmissionListPage.webComponent.draft.labelLanguageOption.native');
}

// Funzione che parsa il tipo di etichetta da renderizzare a video
export const parseLabelType = (labelType) => {
  return labelType === 'legacy' ? 'Classic' : titleize(labelType)
}

// Funzione che parsa il nome di un filtro specifico per le submission lists
export const parseFilterName = (filterName, value) => {
  return searchTranslation('js.PDFGenerator.submissionLists', filterName === 'states' && value.length === 1 ? 'state' : filterName)
}


// Funzione che verifica se un certo nome contiene già al suo interno l'edizione
export const renderEdition = (game_name, edition, name, category_name) => {
  return (
    edition &&
    !["", "Undefined", "Unnumbered", "Numbered"].includes(edition) &&
    name?.toLowerCase().indexOf(edition.toLowerCase()) === -1 &&
    !(edition === '1 Edition' && (
      name?.toLowerCase().indexOf('1st edition') > -1 ||
      name?.toLowerCase().indexOf('1a edizione') > -1 ||
      name?.toLowerCase().indexOf('1 edition') > -1 ||
      name?.toLowerCase().indexOf('1 edizione') > -1 ||
      name?.toLowerCase().indexOf('1st') > -1 ||
      name?.toLowerCase().indexOf('1a') > -1 ||
      name?.toLowerCase().indexOf('1ed') > -1
    )) &&
    game_name !== "Pokémon" &&
    category_name?.toLowerCase() !== 'singles'
  )
}


// Funzione che parsa il nome di un'espansione e la relativa edizione da renderizzare sull'interfaccia grafica
export const parseExpansionNameAndEdition = (expansionName, expansionEdition, gameName) => {
  return expansionName + (renderEdition(gameName, expansionEdition, expansionName, null) ? ' - ' + expansionEdition : '')
}


// Funzione che parsa l'edizione di una certa blueprint_image da renderizzare a video
export const parseBlueprintImageNameAndEdition = (game_name, edition, name, category_name) => {
  return name + (renderEdition(game_name, edition, name, category_name) ? ' - ' + edition : '')
}

// Funzione che parsa il nome di un brand da renderizzare a video
export const parseBrandName = (brand_name) => {
  if (isDefined(brand_name))
    return brand_name;
  else
    return ''
}

// Funzione che parsa il nome di un game da renderizzare a video
export const parseGameName = (game_name, isProduct) => {
  return (
    isProduct ?
      (
        game_name.indexOf('Pokémon') > -1 ? 'Pokémon' : game_name
      )
      :
      (
        game_name === 'ポケモンカードゲーム' || game_name === 'Japanese Pokémon' ?
          I18n.t('js.games.pokemon_jap')
          :
          game_name === '포켓몬 카드 게임' || game_name === 'Korean Pokémon' ?
            I18n.t('js.games.pokemon_kor')
            :
            game_name === '寶可夢 / 宝可梦' || game_name === 'Chinese Pokémon' ?
              I18n.t('js.games.pokemon_zh')
              :
              game_name === 'Pokémon Game Kartu Koleksi' || game_name === 'Indonesian Pokémon' ?
                I18n.t('js.games.pokemon_id')
                :
                game_name === 'โปเกมอน' || game_name === 'Thai Pokémon' ?
                  I18n.t('js.games.pokemon_th')
                  :
                  game_name
      )
  )
}


// Funzione che parsa il nome corretto di un determinato encasing da renderizzare a video
export const parseEncasing = (encasing, categoryName) => {
  if (encasing) {
    if (categoryName) {
      if (["singles", "booster pack"].includes(categoryName.toLowerCase()))
        return (encasing === "sleeve" ? I18n.t("js.encasings.sleeve") : I18n.t("js.encasings.case"));
      else return (encasing === "sleeve" ? I18n.t("js.encasings.scratchproof") : I18n.t("js.encasings.hardcase"));
    } else
      return titleize(encasing);
  } else
    return '';
}


// Funzione che parsa il codice di una carta prepagata
export const parsePrepaidCardCode = (code) => {
  return code.toString().toUpperCase().replace(/(.{4})/g, '$1 ')
}


// Funzione che restituisce il colore da associare all'importo corrente di una certa carta prepagata
export const prepaidCardColorAmount = (amount) => {
  return ['25', '25.0', '25.00', '25,0', '25,00'].includes(amount.toString()) ? '#B95417' :
    ['50', '50.0', '50.00', '50,0', '50,00'].includes(amount.toString()) ? 'darkOrange' :
      ['75', '75.0', '75.00', '75,0', '75,00'].includes(amount.toString()) ? '#E6418B' :
        ['100', '100.0', '100.00', '100,0', '100,00'].includes(amount.toString()) ? '#4cae4c' :
          'gray';
}


// Funzione jquery che mi permette di intercettare quando l'utente smette di scrollare la pagina
// (in qualsiasi direzione) e di eseguire la funzione che gli viene passata come parametro
// quando lo scroll non è più in esecuzione
export const handleStopScroll = (functionOnEndSCroll) => {
  $(window).scroll(function () {
    clearTimeout($.data(this, 'scrollTimer'));
    $.data(this, 'scrollTimer', setTimeout(function () {
      functionOnEndSCroll()
    }, 600));
  });
}


// Funzione che controlla il tasto premuto nei campi di tipo numerico, serve
// per fare in modo che vengano accettati in input solo numeri
export const onKeyDownQuantity = (e) => {
  let checkIfNum;
  if (e.key !== undefined) {
    // Check if it's a "e", ".", "+", "," or "-" or a number
    checkIfNum = e.key === "e" || e.key === "." || e.key === "+" || e.key === "," || e.key === "-" || (e.key >= 0 && e.key <= 9) || e.key === 'Backspace' || e.key === 'Delete'
      || e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowRight';
  }
  else if (e.keyCode !== undefined) {
    // Check if it's a "e" (69), "." (190), "+" (187), "," (188) or "-" (189) or a number
    checkIfNum = e.keyCode === 69 || e.keyCode === 190 || e.keyCode === 187 || e.keyCode === 188 || e.keyCode === 189;
  }
  if (checkIfNum === false) {
    e.preventDefault();
  }
  return checkIfNum;
}


// Funzione che gestisce la pressione del tasto INVIO sulla tastiera da parte dell'utente
export const enterDownHandler = (setDisplayFilters) => {
  const onKeyDown = (e) => {
    if (e.key === 'Enter' && window.innerWidth <= IPAD_WIDTH)
      setDisplayFilters(false)
  }

  document.addEventListener('keydown', onKeyDown);

  return () => {
    document.removeEventListener('keydown', onKeyDown);
  }
}


// Funzione che scrolla in cima alla pagina in cui è invocata la funzione
export const scrollToTopPage = () => {
  window.scrollTo(0, 0);
}


// Funzione che restituisce l'eventuale stringa artwork associata a una certa
// blueprint image, tradotta in una determinata lingua
export const artworkByLocale = (blueprintImage, locale) => {
  return blueprintImage && blueprintImage.artworks && blueprintImage.artworks[`artwork_${parseLocale(locale)}`] ? blueprintImage.artworks[`artwork_${parseLocale(locale)}`] : ''
}


// Funzione che restituisce l'eventuale stringa artwork associata a una certa
// blueprint image, a seconda della lingua impostata per la navigazione sul sito
export const getArtwork = (blueprintImage) => {
  let artwork = artworkByLocale(blueprintImage, I18n.locale)
  if (!artwork && blueprintImage && blueprintImage.artworks && blueprintImage.artworks.artwork_eng) {
    artwork = blueprintImage.artworks.artwork_eng
  }
  return artwork
}


// Funzione che, a partire dal grade numerico in input, restituisce
// la relativa stringa di nomenclatura
export const getGradingNameFromGrade = (grade, is10Perfect) => {
  let gradingName = ['', ''];

  if (['10.5', '10,5'].includes(grade)) {
    gradingName = ['Pristine', 'Pristine'];
  } else if (['10.0', '10,0', '10'].includes(grade) && is10Perfect) {
    gradingName = ['Pristine', 'Pristine'];
  } else if (['10.0', '10,0', '10'].includes(grade) && !is10Perfect) {
    gradingName = ['Gem Mint', 'Gem Mint'];
  } else if (['9.5', '9,5'].includes(grade)) {
    gradingName = ['Mint +', 'Mint+'];
  } else if (['9.0', '9,0', '9'].includes(grade)) {
    gradingName = ['Mint', 'Mint'];
  } else if (['8.5', '8,5'].includes(grade)) {
    gradingName = ['Near Mint/Mint +', 'NM-MT+'];
  } else if (['8.0', '8,0', '8'].includes(grade)) {
    gradingName = ['Near Mint/Mint', 'NM-MT'];
  } else if (['7.5', '7,5'].includes(grade)) {
    gradingName = ['Near Mint +', 'Near Mint+'];
  } else if (['7.0', '7,0', '7'].includes(grade)) {
    gradingName = ['Near Mint', 'Near Mint'];
  } else if (['6.5', '6,5'].includes(grade)) {
    gradingName = ['Excellent/Mint +', 'EX-MT+'];
  } else if (['6.0', '6,0', '6'].includes(grade)) {
    gradingName = ['Excellent/Mint', 'EX-MT'];
  } else if (['5.5', '5,5'].includes(grade)) {
    gradingName = ['Excellent +', 'Excellent+'];
  } else if (['5.0', '5,0', '5'].includes(grade)) {
    gradingName = ['Excellent', 'Excellent'];
  } else if (['4.5', '4,5'].includes(grade)) {
    gradingName = ['Very Good/Excellent +', 'VG-EX+'];
  } else if (['4.0', '4,0', '4'].includes(grade)) {
    gradingName = ['Very Good/Excellent', 'VG-EX'];
  } else if (['3.5', '3,5'].includes(grade)) {
    gradingName = ['Very Good +', 'Very Good+'];
  } else if (['3.0', '3,0', '3'].includes(grade)) {
    gradingName = ['Very Good', 'Very Good'];
  } else if (['2.5', '2,5'].includes(grade)) {
    gradingName = ['Good/Very Good', 'Good-VG'];
  } else if (['2.0', '2,0', '2'].includes(grade)) {
    gradingName = ['Good', 'Good'];
  } else if (['1.5', '1,5'].includes(grade)) {
    gradingName = ['Fair', 'Fair'];
  } else if (['1.0', '1,0', '1'].includes(grade)) {
    gradingName = ['Poor', 'Poor'];
  }

  return gradingName;
}


// Funzione che ritorna il participio passato di un verbo inglese
export const getPastParticiple = (verb) => {
  // Lista dei verbi irregolari comuni con il loro participio passato
  const irregularVerbs = {
    "go": "gone",
    "eat": "eaten",
    "come": "come",
    "see": "seen",
    "take": "taken",
    "write": "written",
    "speak": "spoken",
    "begin": "begun",
    "do": "done",
    "have": "had",
    // Aggiungi altri verbi irregolari qui
  };

  // Se il verbo è irregolare, restituisc0 il participio passato corrispondente
  if (irregularVerbs[verb]) {
    return irregularVerbs[verb];
  }

  if (verb.endsWith('e')) {
    return verb + 'd';
  } else if (verb.endsWith('y')) {
    return verb.slice(0, -1) + 'ied';
  } else if (verb.endsWith('n')) {
    return verb + 'ned';
  } else {
    return verb + 'ed';
  }
}


// Funzione che esegue il parsing sul tid di un certificato di gradazione da renderizzare a video.
// In particolare, aggiunge uno spazio vuoto ogni 6 caratteri del tid
export const parseTid = (tid) => {
  if (isDefined(tid)) {
    return tid.toString().replace(/(.{6})/g, '$1 ');
  } else return '';
}


// Funzione che dice se una determinata stringa sia definita oppure no
export function isDefined(value) {
  return ![null, undefined, ''].includes(value);
}


// Funzione che dice se una determinata stringa sia diversa da null e undefined oppure no
export function isPresent(value) {
  return ![null, undefined].includes(value);
}


// Funzione che dice se una determinata lingua sia presente oppure no
export function isLanguagePresent(language) {
  return isDefined(language) && language.toLowerCase() !== 'xx';
}


// Funzione che dice se un determinato qualifier sia presente oppure no
export function isQualifierPresent(qualifier) {
  return isDefined(qualifier) && qualifier.toLowerCase().trim() !== 'none';
}


// Funzione che esegue il parsing di una determinata lingua:
// se presente, ritorna quella stessa lingua, altrimenti ritorna l'inglese
export function convertLanguage(language) {
  if (isLanguagePresent(language))
    return language;
  else
    return 'en';
}


// Funzione che verifica se un dato array di oggetti ricevuti in input contiene al suo interno un oggetto avente
// uno specifico valore associato a una specifica chiave
export const customIncludes = (array, key, value) => {
  return array.some((obj) => obj.hasOwnProperty(key) && obj[key] === value);
}


// Funzione che ritorna la valutazione complessiva data dall'utente a una certa submission list
export const overallEvaluation = (evaluations) => {
  if (isDefined(evaluations)) {
    const presentEvaluations = Object.values(evaluations).filter((evaluation) => evaluation > 0)
    let evaluationsSum = 0;
    for (const evaluation of presentEvaluations)
      evaluationsSum += evaluation
    return Math.floor(evaluationsSum / presentEvaluations.length)
  } else {
    return 0;
  }
}


// Funzione che, dato un array di oggetti, raggruppa gli elementi di quell'array in base al valore di una chiave di
// input
export const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};


// Funzione che, dato un array di oggetti, raggruppa gli elementi di quell'array in base al valore di una chiave di
// input preservandone l'ordinamento iniziale
export const groupByAndKeepOrder = function (arr, prop) {
  var newArr = [] // array to return, keeps track of order
  var wrapObj = {}; // temporary object used for grouping

  _.forEach(arr, function (item) {

    // gets property name to group by and converts it to a string for grouping purposes
    var propName = item[prop];
    if (propName) {
      propName = propName.toString();

      // checks if group exists already and creates a new group if not, pushing it into the array to return ('newArr')
      if (!wrapObj[propName]) {
        wrapObj[propName] = [];
        newArr.push(wrapObj[propName]);
      }

      // adds item to the group
      wrapObj[propName].push(item);
    } else {
      console.warn("utils -> groupByKeepOrder", "Property '" + prop + "' not found within object. It will be ignored from the output.", item);
    }
  });

  return newArr
}



// Funzione che restituisce un numero casuale compreso tra 0 e 255
export const generateRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
}



// Funzione che covnerte un oggetto in un formData
export const createFormData = (obj, formData = new FormData(), parentKey = '') => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      // Creo la chiave completa (tenendo conto del livello di annidamento)
      const newKey = parentKey ? `${parentKey}[${key}]` : key;

      // Se il valore è un oggetto e non è nullo, chiamo la funzione ricorsivamente
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        // Se il valore è un file o un blob, lo aggiungo direttamente al FormData
        if (obj[key] instanceof File || obj[key] instanceof Blob) {
          formData.append(newKey, obj[key], obj[key].name);
        } else if (Array.isArray(obj[key])) {
          obj[key].forEach((item, index) => {
            createFormData(item, formData, `${newKey}[${index}]`);
          });
        } else
          createFormData(obj[key], formData, newKey);
      } else {
        // Se il valore non è nullo, lo aggiungo al FormData
        if (isPresent(obj[key])) {
          formData.append(newKey, obj[key]);
        }
      }
    }
  }
  return formData;
}

// Funzione che converte in maniera deterministica un numero in un colore
export const numberToColor = (number, saturation = 100, lightness = 50) => {
  const goldenAngle = 137.508
  const hue = (number * goldenAngle) % 360

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}

//Funzione che ritorna le iniziali di un utente
export const toInitials = (user) => {
  const words = [user.first_name, user.last_name, !isDefined(user.first_name) && !isDefined(user.last_name) ? user.email : null].filter(n => n)

  return words
    .join(' ')
    .trim()
    .split(/\s+/)
    .map(word => word[0]?.toUpperCase())
    .join('')
}


// Funzione che setta il messaggio di errore da renderizzare sul backoffice nel caso si tenti di lanciare un
// aggiornamento di immagini quando è in corso un deploy sul server
export const DEPLOYMENT_IN_PROGRESS_ERROR_MESSAGE = "At the moment, images update is not available because a deployment is in progress. Please, try again later.";

export const setImagesUploadErrorMessage = (error, setErrorMessage) => {
  if (error.toString().indexOf("deployment in progress") > -1) {
    setErrorMessage(DEPLOYMENT_IN_PROGRESS_ERROR_MESSAGE);
    removeHtmlElementClass(document, 'deploy_alert', 'd-none');
    addHtmlElementClass(document, 'deploy_alert', 'd-flex');
    addHtmlElementClass(document, 'start_deploy_btn', 'd-none');
  }
}




// MEOTID DI UTILS PER I WEB-COMPONENTS

// Funzione che ri-renderizza un intero web-component sulla pagina html
export const renderWebComponent = (html, root, styles) => {
  removeHtmlChildren(root);

  // Importo gli stili di bootstrap
  const link = document.createElement("link");
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('media', 'screen');
  link.setAttribute('href', "https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css");
  appendHtmlElementChild(root, link);

  // Importo eventuali stili custom da associare alla pagina
  if (styles && styles.length > 0) {
    for (const style of styles) {
      const stylesheet = document.createElement("style");
      stylesheet.innerHTML = style.toString()
      appendHtmlElementChild(root, stylesheet);
    }
  }

  // Innesto l'html all'interno del web-component
  const template = document.createElement('template')
  template.innerHTML = html
  appendHtmlElementChild(root, template.content.cloneNode(true));
}


export const isNumber = (value) => {
  return !isNaN(value) && !isNaN(parseFloat(value));
}

export const sanitize = (value) => {
  if (isNumber(value))
    return value;
  else
    return DOMPurify.sanitize(value);
}

export const removeHtmlElement = (root, id) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.remove();
}

export const removeHtmlChildren = (root) => {
  if (root) {
    let firstChild = root.firstChild;
    while (firstChild) {
      root.removeChild(firstChild);
      firstChild = root.firstChild;
    }
  }
}

export const removeHtmlChild = (root, id) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.parentNode.removeChild(elem);
}

export const getHtmlElement = (root, id) => {
  return root.querySelector(`#${CSS.escape(id)}`);
}

export const getHtmlElementValue = (root, id) => {
  return getHtmlElement(root, id)?.value;
}

export const appendHtmlElementChild = (root, child) => {
  if (root && child)
    root.appendChild(child);
}

export const setHtmlElementContent = (root, id, content) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.textContent = content;
}

export const setHtmlElementAttribute = (root, id, attribute, value) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.setAttribute('src', value)
}

export const setHtmlElementValue = (root, id, value) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.value = value;
}

export const addHtmlElementClass = (root, id, className) => {
  const elem = getHtmlElement(root, id);
  if (elem && !elem.classList.contains(className))
    elem.classList.add(className);
}

export const toggleHtmlElement = (root, id, className) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.classList.toggle(className);
}

export const setHtmlElementClasses = (root, id, classes) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.className = classes;
}

export const setHtmlElementStyle = (root, id, key, value) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.style[key] = value
}

export const removeHtmlElementClass = (root, id, className) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.classList.remove(className);
}

export const addHtmlElementEventListener = (root, id, event, fun, removeAllPreviousEventListeners) => {
  let elem = getHtmlElement(root, id);
  if (elem) {
    if (removeAllPreviousEventListeners)
      elem = removeAllEventListeners(elem);
    elem.addEventListener(event, fun);
  }
}

export const addHtmlRootEventListener = (root, event, fun) => {
  root.addEventListener(event, fun);
}

export const removeAllEventListeners = (elem) => {
  if (elem) {
    const clone = elem.cloneNode(true);
    elem.replaceWith(clone);
    return clone;
  }
}

export const enableHtmlElement = (root, id, enabling) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.disabled = !enabling;
}

export const selectHtmlElement = (root, id, selected) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.selected = selected;
}

export const checkHtmlElement = (root, id, checked) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.checked = checked;
}

export const focusHtmlElement = (root, id) => {
  const elem = getHtmlElement(root, id);
  if (elem)
    elem.focus();
}

export const isHtmlElementIntoView = (elem) => {
  if (elem) {
    const rect = elem.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  return false;
}

export const scrollHtmlElementIntoView = (root, id, scrolling) => {
  const elem = getHtmlElement(root, id);
  if (elem && !isHtmlElementIntoView(elem)) {
    elem.scrollIntoView(scrolling);
  }
}


// Funzione che converte una stringa in oggetto JSON
export const string2obj = (string) => {
  const reviver = (key, value) => {
    if (typeof value === "string")
      return value.replaceAll('#_#', ' ').replaceAll("&#39;", "'");
    return value;
  }
  return JSON.parse(string, reviver);
}


// Funzione che converte un oggetto JSON in una stringa
export const obj2string = (obj) => {
  const replacer = (key, value) => {
    if (typeof value === "string")
      return value.replaceAll(' ', '#_#').replaceAll("'", "&#39;");
    return value;
  }
  return JSON.stringify(obj, replacer);
}

//Funzione che stampa l'etichetta cartacea di una submissionList appena ricevuta
export const printReceivedSubmissionLabel = (receivedSubmissionList) => {
  const printContent = `
  <div class="text-center border-black">
    <h1>N° ${receivedSubmissionList.number}</h1>
    <p>Received: ${receivedSubmissionList.received_at.split(',')[0]}</p>
    <p>Products: ${receivedSubmissionList.items_count}</p>
    <p>(${receivedSubmissionList.case_items_count}c/${receivedSubmissionList.sleeve_items_count}s)</p>
    ${receivedSubmissionList.middleman ?
      `<h2>AIG POINT</h2><h3>${receivedSubmissionList.middleman.business_name} - ${receivedSubmissionList.middleman.warehouse_location}</h3>`
      :
      '<h2>DIRETTO</h2>'
    }
    <p>Top Loader</p>
    <p>   Si   /   No   </p>
  </div>
  `;
  printIFrameFromBrowser(printContent);
}

//Funzione che avvia una stampa cartacea dal browser
export const printIFrameFromBrowser = (printContent) => {
  // Crea un iframe invisibile
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0px';
  iframe.style.height = '0px';
  iframe.style.border = 'none';
  document.body.appendChild(iframe);

  // Ottieni gli stili CSS dal documento principale
  const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'));

  // Scrivi il contenuto nell'iframe
  iframe.contentWindow.document.open();
  iframe.contentWindow.document.write(printContent);

  // Aggiungi gli stili CSS all'iframe
  styles.forEach(style => {
    iframe.contentWindow.document.head.appendChild(style.cloneNode(true));
  });

  iframe.contentWindow.document.close();

  // Avvia la stampa nell'iframe
  iframe.contentWindow.print();


  // Rimuovi l'iframe dopo la stampa
  iframe.contentWindow.onafterprint = function () {
    document.body.removeChild(iframe);
  };
}


// DEBOUNCE: Funzione che prende in input una funzione e un tempo,
// ed esegue la funzione debouncata del lasso di tempo ricevuto in input
export const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
}

export const lowDebouncedFunction = debounce(function (fun, args) {
  fun(...args);
}, LOW_DEBOUNCE_TIME);

export const highDebouncedFunction = debounce(function (fun, args) {
  fun(...args);
}, HIGH_DEBOUNCE_TIME);

export const veryHighDebouncedFunction = debounce(function (fun, args) {
  fun(...args);
}, VERY_HIGH_DEBOUNCE_TIME);

export const veryVeryHighDebouncedFunction = debounce(function (fun, args) {
  fun(...args);
}, VERY_VERY_HIGH_DEBOUNCE_TIME);